/* eslint-disable camelcase */
/* This class contains the same logic as is present in IdRegValidation.gs class in Claim Center codebase.
*/
import {
    ModalNextProvider
} from '@jutro/components';
import {
    messages as commonMessages
} from 'gw-platform-translations';

import moment from 'moment';
import {
    DateUtil
} from 'gw-portals-util-js';
import _ from 'lodash';

const allower_company = ['06', '07', '08', '09', '10', '12', '21', '22', '23', '24', '25', '26', '30', '31'];
const id_month_Start = Number(1);
const id_month_end = Number(12);
const id_day_Start = Number(1);
const id_day_end = Number(31);
const modulus_ten = Number(10);

function handleRegError() {
    ModalNextProvider.showAlert({
        title: 'Error',
        message: 'Insured Registration Number format is incorrect - please correct the number',
        status: 'error',
        icon: 'mi-error-outline',
        confirmButtonText: commonMessages.ok
    }).catch(_.noop);
}

function handleIdError() {
    ModalNextProvider.showAlert({
        title: 'Error',
        message: 'Insured Identity Number format is incorrect - please correct the number',
        status: 'error',
        icon: 'mi-error-outline',
        confirmButtonText: commonMessages.ok
    }).catch(_.noop);
}

function validateRegNoCheckSum(registrationNo) {

    const idLen = registrationNo.length;
    if (idLen !== 14) {
        handleRegError();
        return false;
    }
    let year = registrationNo.charAt(0) + registrationNo.charAt(1) + registrationNo.charAt(2) + registrationNo.charAt(3);
    year = Number(year);
    const companyYear = registrationNo.charAt(12) + registrationNo.charAt(13);
    const currentDate = DateUtil.currentDate();
    const currentYr = currentDate.getFullYear();
    if (year > currentYr) {
        handleRegError();
        return false;
    }

    if (!allower_company.includes(companyYear.toString())) {
        handleRegError();
        return false;
    }

    return true;
}

function validateIdNo(idNo) {
    let idMonth = idNo.charAt(2) + idNo.charAt(3);
    idMonth = Number(idMonth);
    let idDay = idNo.charAt(4) + idNo.charAt(5);
    idDay = Number(idDay);
    let idForeigner = idNo.charAt(10);
    idForeigner = Number(idForeigner);
    // eslint-disable-next-line camelcase
    if ((idMonth < id_month_Start || idMonth > id_month_end) ||
        (idDay < id_day_Start || idDay > id_day_end) ||
        !(idForeigner === 0 || idForeigner === 1)) {
        handleIdError();
        return false;
    }
    const oddSum = Number(idNo.charAt(0)) + Number(idNo.charAt(2)) + Number(idNo.charAt(4)) + Number(idNo.charAt(6)) + Number(idNo.charAt(8)) + Number(idNo.charAt(10));
    let evenNum = (idNo.charAt(1)) + (idNo.charAt(3)) + (idNo.charAt(5)) + (idNo.charAt(7)) + (idNo.charAt(9)) + (idNo.charAt(11));
    evenNum = Number(evenNum) * 2;
    let evenSum = 0;
    while (evenNum > 0) {
        evenSum = (evenSum + evenNum % modulus_ten);
        evenNum = Math.floor(evenNum / modulus_ten);
    }
    const totalSum = Number(oddSum + evenSum);
    const checkSum = Number(modulus_ten - totalSum % modulus_ten);
    if (checkSum.toString().length === 1 && checkSum !== Number(idNo.charAt(12))) {
        handleIdError();
        return false;
    } else if (checkSum.toString().length > 1 && checkSum.toString().charAt(1) !== idNo.charAt(12)) {
        handleIdError();
        return false;
    }
    return true;

}

export {
    validateRegNoCheckSum,
    validateIdNo
};